import { Injectable, inject } from '@angular/core'
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router, RoutesRecognized } from '@angular/router'
import { filter, map, pairwise, tap } from 'rxjs'
import { RouteService } from './route.service'

@Injectable({
    providedIn: 'root',
})
export class RouterStateService {
    private router = inject(Router)
    private route = inject(ActivatedRoute)
    private routeService = inject(RouteService)

    private routeHistory: Record<string, string> = {}

    subscribeRouterStateChanges(): void {
        this.router.events
            .pipe(
                filter((event) => event instanceof RoutesRecognized),
                map((event) => event as RoutesRecognized),
                pairwise(),
                tap((val: RoutesRecognized[]) => {
                    let previousUrl = val[0].urlAfterRedirects
                    const currentUrl = val[1].urlAfterRedirects
                    let parentUrl = ''

                    const prevUrlLen = previousUrl.split('?')[0].split('/')
                    const currentUrlLen = currentUrl.split('?')[0].split('/')

                    const intersection = prevUrlLen.filter((value) => currentUrlLen.includes(value))
                    const urlDiff = intersection.slice(1)

                    if (urlDiff.length === 0) {
                        this.routeHistory = {}
                        previousUrl = ''
                    }

                    if (urlDiff.length > 0) {
                        if (currentUrlLen.length > prevUrlLen.length) {
                            parentUrl = previousUrl
                        }
                    }

                    if (parentUrl) {
                        const moduleParent = parentUrl.split('?')[0]
                        this.routeHistory[moduleParent] = parentUrl
                    }

                    this.routeService.setCurrentRoute(currentUrl)
                    this.routeService.setParentRoute(parentUrl)
                    this.routeService.setPreviousRoute(previousUrl)
                })
            )
            .subscribe()

        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                map(() => this.route.snapshot),
                map((route) => this.routeFirstChild(route))
            )
            .subscribe((route: ActivatedRouteSnapshot) => {
                this.routeService.setData(route.data)
            })
    }

    routeFirstChild(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
        while (route.firstChild) {
            route = route.firstChild
        }

        return route
    }
}
